import { Suspense } from 'react'
import { Canvas, useThree } from '@react-three/fiber'
import './styles.css'
import { Environment, Stars, MeshReflectorMaterial } from '@react-three/drei'
import Particles from './Particles'
import CameraAnimation from './CameraAnimation'
import Effects from './Effects'
import Modell from './Model1'
import { useSnapshot } from 'valtio'
import { state } from './store'

function ResponsiveScene({ selectedColor }) {
  const { viewport } = useThree()
  const isMobile = viewport.width < 6
  const isTablet = viewport.width < 9

  const groupScale = isMobile ? 0.67 : isTablet ? 0.83 : 1
  const offsetY = isMobile ? -0.55 : isTablet ? -0.15 : 0

  return (
    <group scale={groupScale} position-y={offsetY}>
      <Modell transitionColor={selectedColor} castShadow scale={3} position={[0, -2.43, 0]} rotation={[0, 0, 0]} />

      <mesh receiveShadow scale={5.5} position={[0.5, -2.399, 0.5]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
        <ringGeometry args={[0.9, 1, 4, 1]} />
        <meshBasicMaterial color="#2d5363" />
      </mesh>

      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, -2.4, -1]}>
        <planeGeometry args={[55, 55]} />
        <MeshReflectorMaterial
          blur={[100, 100]}
          resolution={512}
          mixBlur={0.9}
          mixStrength={300}
          roughness={0.8}
          depthScale={2.2}
          minDepthThreshold={1.4}
          maxDepthThreshold={1.4}
          color="#101010"
          metalness={1}
        />
      </mesh>
    </group>
  )
}

function Scene() {
  const { selectedColor } = useSnapshot(state)
  return (
    <Canvas shadows camera={{ position: [0, 0, 4] }} gl={{ antialias: true, powerPreference: 'high-performance' }} dpr={[1, 1.5]}>
      <fogExp2 attach="fog" args={['#004662', 0.05]} />
      <color attach="background" args={['#004662']} />

      <Suspense fallback={null}>
        <ResponsiveScene selectedColor={selectedColor} />

        <Stars
          radius={80}
          depth={60}
          count={1500}
          factor={3}
          saturation={0}
          fade
          speed={0.5}
        />

        <Environment preset='studio' environmentIntensity={0.2} resolution={50} />

        <directionalLight
          castShadow
          position={[5, 10, 10]}
          intensity={3}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
        />

        <Particles particlesCount={40} />

        <hemisphereLight intensity={1.2} />
        <Effects />
        <CameraAnimation />
      </Suspense>
    </Canvas>
  )
}

export default Scene
